// ---------------------------------------------------------------------------
// Chromecast nativo (cordova-plugin-chromecast). Il plugin espone l'API
// standard chrome.cast SOLO dentro l'app: sul web i bottoni Cast sono già
// nascosti da web.css (html:not(.ty-native)).
//
// Modello "telecomando": in cast il video continua a girare in locale MUTO e
// i comandi del player (play / pause / seek / sottotitoli) vengono replicati
// sul ricevitore. L'aggancio al player della pagina video lo fa
// bindPlayerToCast, chiamata da createVideoSection a ogni video aperto.
//
// Entry point pubblici: initializeCast (app.js, al boot),
// requestCastSession (bottoni Cast), bindPlayerToCast (live.js).
// ---------------------------------------------------------------------------

// Stato della sessione
var _castSession = null;
var _castMedia = null;
var _castConnected = false;   // ultimo stato notificato: serve alle transizioni
var _castSource = null;       // sorgente del video attualmente in pagina
var _castSourceType = null;

// chrome.cast va letto SEMPRE lazy: il plugin lo inietta a deviceready e su
// iOS window.chrome prima non esiste nemmeno — una var catturata al load del
// file resterebbe undefined per sempre.
function castApi() {
    return (window.chrome && window.chrome.cast) ? window.chrome.cast : null;
}

function castIsConnected() {
    return !!_castSession;
}

function initializeCast () {
    var cast = castApi();
    if (!cast) {
        // nessun plugin (web, o build senza Chromecast): via i bottoni Cast
        document.documentElement.classList.add('no-cast');
        return false;
    }
    document.documentElement.classList.remove('no-cast');

    // receiver di default (nessuna app custom registrata)
    var appId = cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID;
    var apiConfig = new cast.ApiConfig(new cast.SessionRequest(appId), sessionListener, receiverListener);

    cast.initialize(apiConfig, function () {
        // initialize completata: da qui sessionListener e receiverListener
        // ricevono gli aggiornamenti
    }, function (err) {
        console.log('cast: initialize', err);
    });
    return true;
}

setInterval(checkChromecastStatus, 1000);

// Apre il dialog nativo di scelta del ricevitore (se già connessi permette
// anche di disconnettersi) e, appena c'è una sessione, manda in cast la
// sorgente corrente. Senza argomenti usa il video aperto in pagina.
function requestCastSession(url, type) {
    var cast = castApi();
    if (!cast) { return false; }

    var src = url || _castSource;
    var srcType = type || _castSourceType;

    cast.requestSession(function (session) {
        sessionListener(session);
        if (src) { loadMedia(src, srcType); }
    }, function (err) {
        // err 'cancel' = dialog chiuso dall'utente, non è un errore
        console.log('cast: requestSession', err);
    });
    return true;
}

// Chiamata sia da chrome.cast.initialize (sessione già attiva ripresa al
// boot dell'app) sia da requestSession.
function sessionListener(session) {
    if (!session || _castSession === session) { return; }
    _castSession = session;

    // sessione ripresa con un media già in riproduzione sul ricevitore
    if (session.media && session.media.length) {
        _castMedia = session.media[0];
    }

    session.addUpdateListener(function (isAlive) {
        if (!isAlive) {
            _castSession = null;
            _castMedia = null;
        }
        checkChromecastStatus();
    });

    checkChromecastStatus();
}

// Disponibilità dei ricevitori in rete: senza nessuna Chromecast raggiungibile
// il bottone Cast non ha senso e sparisce (stile YouTube). Se il plugin non
// notifica mai nulla il bottone resta visibile: mai nascondere per default.
function receiverListener(availability) {
    var cast = castApi();
    var AVAILABLE = (cast && cast.ReceiverAvailability) ? cast.ReceiverAvailability.AVAILABLE : 'available';
    var has = (availability === true || availability === AVAILABLE);
    document.documentElement.classList.toggle('no-cast-receiver', !has);
}

// Carica una sorgente sul ricevitore e la allinea allo stato del player
function loadMedia(url, type) {
    var cast = castApi();
    if (!cast || !_castSession || !url) { return false; }

    var mediaInfo = new cast.media.MediaInfo(url, type || 'application/vnd.apple.mpegurl');

    _castSession.loadMedia(new cast.media.LoadRequest(mediaInfo), function (media) {
        _castMedia = media;
        updateCastSubtitles(currentVIdeoSubtitle);
        syncCastToPlayer();
        try { teyutoVideoPlayer.muted(true); } catch (error) {}
    }, function (err) {
        console.log('cast: loadMedia', err);
    });
    return true;
}

// Porta il ricevitore sulla posizione e sullo stato play/pausa del player
// locale (dopo un loadMedia il receiver riparte sempre da 0 in play)
function syncCastToPlayer() {
    try {
        var t = teyutoVideoPlayer.currentTime();
        if (t > 1) { seekMedia(t); }
        if (teyutoVideoPlayer.paused()) { pauseMedia(); }
    } catch (error) {}
}

function pauseMedia() {
    if (!_castMedia) { return false; }
    _castMedia.pause({}, function () {
        // Success
    }, function (err) {
        console.log('cast: pause', err);
    });
    return true;
}

function playMedia() {
    if (!_castMedia) { return false; }
    _castMedia.play({}, function () {
        // Success
    }, function (err) {
        console.log('cast: play', err);
    });
    return true;
}

function seekMedia(time) {
    var cast = castApi();
    if (!cast || !_castMedia) { return false; }

    var seekRequest = new cast.media.SeekRequest();
    seekRequest.currentTime = time;

    _castMedia.seek(seekRequest, function () {
        // Success
    }, function (err) {
        console.log('cast: seek', err);
    });
    return true;
}

function stopSession() {
    if (!_castSession) { return false; }
    _castSession.stop(function () {
        _castSession = null;
        _castMedia = null;
        checkChromecastStatus();
    }, function (err) {
        console.log('cast: stop', err);
    });
    return true;
}

// Aggancia il player della pagina video al cast. I listener vivono quanto il
// player (dispose a ogni cambio video), quindi non serve sganciarli.
function bindPlayerToCast(player, source, sourceType) {
    _castSource = source || null;
    _castSourceType = sourceType || null;
    if (!player) { return false; }

    player.on('play', function () { playMedia(); });
    player.on('pause', function () { pauseMedia(); });
    player.on('seeked', function () {
        try { seekMedia(player.currentTime()); } catch (error) {}
    });

    // sottotitoli: la traccia scelta nel menu della skin va replicata sul
    // ricevitore e ricordata per il prossimo loadMedia
    try {
        player.textTracks().addEventListener('change', function () {
            var tracks = Array.prototype.slice.call(player.textTracks());
            var active = tracks.filter(function (track) {
                return track.language && track.mode === 'showing';
            })[0];

            currentVIdeoSubtitle = {
                trackId: active ? active.id : null,
                language: active ? active.language : null,
                label: active ? active.label : null
            };
            updateCastSubtitles(currentVIdeoSubtitle);
        });
    } catch (error) {}

    // già in cast: il video appena aperto parte subito sul ricevitore
    if (castIsConnected() && source) {
        loadMedia(source, sourceType);
    }
    return true;
}

// La sorgente non è più quella di un video in pagina (uscita dalla pagina
// video, oppure live che cambia src): senza questo il bottone Cast
// dell'header rimanderebbe sul ricevitore l'ultimo video aperto.
function setCastSource(source, sourceType) {
    _castSource = source || null;
    _castSourceType = sourceType || null;
    if (castIsConnected() && source) {
        loadMedia(source, sourceType);
    }
}

// Tick di stato (1s). L'indicatore va riapplicato a ogni giro perché il
// bottone Cast della pagina video viene ricreato a ogni video; il mute del
// player locale invece SOLO sulle transizioni, o sovrascriverebbe ogni
// secondo il mute deciso dall'utente.
function checkChromecastStatus() {
    var connected = castIsConnected();
    var changed = (connected !== _castConnected);

    // fuori dal cast non c'è niente da riapplicare a ogni giro: lo stato di
    // riposo è già quello del CSS
    if (connected || changed) {
        $('.mobile-chromecast-icon').css('opacity', connected ? 1 : 0.7);
        $('.controlButtonCast').toggleClass('cast-connected', connected);
    }

    if (!changed) { return; }
    _castConnected = connected;

    if (!connected) { _castMedia = null; }

    // in cast il player locale resta il telecomando: continua a girare muto
    try { teyutoVideoPlayer.muted(connected); } catch (error) {}
}

// Attiva sul ricevitore la traccia sottotitoli corrispondente a quella scelta
// nel player (match per lingua: gli id delle tracce non coincidono)
function updateCastSubtitles(trackInfo) {
    var cast = castApi();
    if (!cast || !_castMedia || !trackInfo) { return false; }

    var sidetrackId = [];
    var tracks = _castMedia.media ? _castMedia.media.tracks : null;

    if (tracks && tracks.length > 0) {
        tracks.forEach(function (track) {
            if (track.type == "TEXT" && trackInfo.language == track.language) {
                sidetrackId.push(track.trackId);
            }
        });
    } else {
        console.log('cast: nessun track disponibile per questo media');
        return false;
    }

    _castMedia.editTracksInfo(new cast.media.EditTracksInfoRequest(sidetrackId), function () {
        // Success
    }, function (err) {
        console.log('cast: editTracksInfo', err);
    });
    return true;
}
